/* BareLamper — bare-countup.js
   Tæller tal op, når kortet bliver synligt. Kører én gang pr. element,
   respekterer prefers-reduced-motion og genstarter korrekt i Theme Editor. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function formatNumber(value, decimals) {
    return value.toLocaleString('da-DK', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  function finish(el, to, decimals) {
    el.textContent = formatNumber(to, decimals);
    el.dataset.blDone = '1';
  }

  function animate(el) {
    if (el.dataset.blDone) return;
    var from = parseFloat(el.dataset.from) || 0;
    var to = parseFloat(el.dataset.to) || 0;
    var decimals = parseInt(el.dataset.decimals, 10) || 0;
    var duration = parseInt(el.dataset.duration, 10) || 1400;

    if (reduced || el.dataset.animate === 'false') { finish(el, to, decimals); return; }

    el.dataset.blDone = '1';
    var t0 = null;
    function tick(t) {
      if (t0 === null) t0 = t;
      var p = Math.min((t - t0) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = formatNumber(from + (to - from) * eased, decimals);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function ensureObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animate(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    return observer;
  }

  function initAll(scope) {
    var els = (scope || document).querySelectorAll('[data-bl-count]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        finish(el, parseFloat(el.dataset.to) || 0, parseInt(el.dataset.decimals, 10) || 0);
      });
      return;
    }
    var io = ensureObserver();
    els.forEach(function (el) {
      delete el.dataset.blDone;
      io.observe(el);
    });
  }

  function destroyAll(scope) {
    if (!observer) return;
    (scope || document).querySelectorAll('[data-bl-count]').forEach(function (el) {
      observer.unobserve(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyAll(e.target); });
})();
